import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { EntLeasingOperator } from "../../../models/handBooks/leasingOperator";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { Paths } from "../../../paths";

export const leasingOperatorApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({
        getLeasingOperatorList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
            query: (filter) => ({
                url: `${Paths.handbooks.leasingoperator}/get-all`,
                method: "POST",
                body: JSON.stringify(filter)
            }),
        }),
        getLeasingOperatorById: builder.query<ResponseDataTest<EntLeasingOperator>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.leasingoperator}/${id}`,
                method: 'GET'
            })
        }),
        addLeasingOperator: builder.mutation<ResponseDataTest<EntLeasingOperator>, EntLeasingOperator>({
            query: (body) => ({
                url: `${Paths.handbooks.leasingoperator}`,
                method: "POST",
                body: JSON.stringify(body)
            }),
        }),
        editLeasingOperator: builder.mutation<ResponseDataTest<EntLeasingOperator>, EntLeasingOperator>({
            query: (body, ) => ({
                url: `${Paths.handbooks.leasingoperator}`,
                method: 'PUT',
                body: JSON.stringify(body),
            }),
            onQueryStarted: async (user, { dispatch, queryFulfilled }) => {}
        }),
        deleteLeasingOperator: builder.mutation<ResponseDataTest<EntLeasingOperator>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.leasingoperator}/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
useAddLeasingOperatorMutation,
useDeleteLeasingOperatorMutation,
useEditLeasingOperatorMutation,
    useLazyGetLeasingOperatorListQuery
} = leasingOperatorApi;
